import { LocalePrefix, Pathnames } from "next-intl/routing";

export const locales = ["en", "ar"] as const;

export const defaultLocale = "ar";

export type Locales = typeof locales;

export const pathnames: Pathnames<Locales> = {
  "/": "/",
  "/pathnames": "/pathnames",
  "/sign/email": "/sign/email",
  "/sign/otp": "/sign/otp",
  "/sign/document": "/sign/document",
  "/sign/error": "/sign/error",
};

export const localePrefix: LocalePrefix<Locales> = "always";
